import PersonalDefaultPage from "./PersonalDefaultPage";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import axios from "axios";
import Config from "../../Config";
import { setAllLessons } from "../../store/LessonsProgramSlice";
import { useNavigate } from "react-router-dom";
import { get_user } from "../../components/blocks/profileUpdating/dataUpdating/ProfileDataUpdatingBlock";
import { setUser } from "../../store/UserSlice";
import { useWindowDimensions } from "../../utils";
import { ProgramHeader } from "./program/ProgramHeader";
import { ProgramMap } from "./program/ProgramMap";
import { ProgramFooter } from "./program/ProgramFooter";
import { ProgramLevelsList } from "./program/ProgramLevelsList";
import { ProgramPageWrap } from "./program/ProgramMap.styles";
import { shouldUseClassicProgramLayout } from "./program/programLayout";

export const LessonsProgram = () => {
    const { width: screenWidth } = useWindowDimensions();
    const isClassicLayout = shouldUseClassicProgramLayout(screenWidth);
    const navigate = useNavigate();
    const user = useSelector(state => state.user);
    const lessonsProgram = useSelector(state => state.lessonsProgram);
    const dispatch = useDispatch();

    useEffect(() => {
        (async () => {
            if (!user || Object.keys(user).length === 0) {
                try {
                    const data = await get_user();
                    dispatch(setUser(data));
                } catch (error) {
                    console.error("Error fetching user data:", error);
                }
            }
        })();
    }, [dispatch, user]);

    useEffect(() => {
        axios.get(Config.BACKEND_ADDR + "/levels/").then(res => {
            const levelsData = res.data;
            levelsData.sort((a, b) => (a.id > b.id ? 1 : b.id > a.id ? -1 : 0));
            dispatch(setAllLessons(levelsData.map(el => ({
                id: el.id,
                level: el.name,
                age: el.age_description,
                image: Config.CLOUD_ADDR + "/" + el.image_path,
                summary: el.description,
                lessons: el.materials.map(material => ({
                    id: material.id,
                    image: material.image_path,
                    file: material.index_html_path,
                    level: material.level_id,
                    name: material.name,
                    completed: true,
                    index: material.index,
                })),
            }))));
        });
    }, [dispatch]);

    useEffect(() => {
        const backendAddr = Config.BACKEND_ADDR + "/payments/getSubscriptionPeriod";
        axios.get(backendAddr).then(response => {
            if (response.status === 200 && response.data.status === "not_paid") {
                navigate("/billing/");
            }
        }).catch(err => {
            console.warn("Ошибка проверки подписки в БД! ", err);
        });
    }, [navigate]);

    return (
        <PersonalDefaultPage>
            {isClassicLayout ? (
                <ProgramLevelsList levels={lessonsProgram} />
            ) : (
                <ProgramPageWrap>
                    <ProgramHeader />
                    <ProgramMap levels={lessonsProgram} />
                    <ProgramFooter />
                </ProgramPageWrap>
            )}
        </PersonalDefaultPage>
    );
};
